import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import { Skeleton } from "@/components/ui/skeleton";

// loading de graphes
export const ChartSkeleton = () => {
  return (
    <>
      <div className="mb-4 basis-1/2 h-[400px] bg-[#F7F9FB] rounded-[20px]">
        <div className="flex flex-row items-center justify-start mx-5">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#bdbebf"
            strokeWidth="1.75"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-chevron-down-icon lucide-chevron-down"
          >
            <path d="m6 9 6 6 6-6" />
          </svg>
          <Skeleton className="rounded-full w-[150px] h-5 m-5 bg-[#ecedee]" />
        </div>
        <div className="grid grid-cols-2">
          <div className="flex flex-col justify-between">
            <Skeleton className="rounded-full w-[50px] h-3 m-5 bg-[#ecedee]" />
            <Skeleton className="rounded-full w-[50px] h-3 m-5 bg-[#ecedee]" />
            <Skeleton className="rounded-full w-[50px] h-3 m-5 bg-[#ecedee]" />
          </div>
          <div>
            <div className="flex flex-row gap-16  items-end justify-end mx-5">
              <Skeleton className="rounded-full w-[25px] h-[100px] bg-[#ecedee]" />
              <Skeleton className="rounded-full w-[25px] h-[200px] bg-[#ecedee]" />
              <Skeleton className="rounded-full w-[25px] h-[275px] bg-[#ecedee]" />
              <Skeleton className="rounded-full w-[25px] h-[250px] bg-[#ecedee]" />
            </div>
          </div>
        </div>
        <div className="flex flex-row justify-between">
          {Array.from({ length: 7 }).map((i, k) => (
            <Skeleton
              className="rounded-full w-[50px] h-3 m-5 bg-[#ecedee]"
              key={k}
            />
          ))}
        </div>
      </div>
    </>
  );
};

// loadind pour un carousel
export const CarouselSkeleton = () => {
  return (
    <div>
      <div>
        <Carousel
          opts={{
            align: "start",
          }}
          className="m-5 w-auto"
        >
          <CarouselContent>
            {Array.from({ length: 8 }).map((_, i) => (
              <CarouselItem
                key={i}
                className="md:basis-1/5 lg:basis-1/6 xl:basis-[13%]"
              >
                <div className="p-1">
                  <Skeleton className="rounded-[15px] w-full h-[100px]" />
                  <Skeleton className="rounded-[15px] w-full h-[20px] my-2" />
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselPrevious />
          <CarouselNext />
        </Carousel>
      </div>
      <div></div>
    </div>
  );
};
export const TypeSkeleton = () => {
  return (
    <div className="m-5">
      {Array.from({ length: 4 }).map((_, i) => (
        <div
          key={i}
          className="  mx-0  my-4 flex  w-full flex-row items-center justify-between"
        >
          <Skeleton className="w-1/3 h-5 bg-[#ecedee] rounded-[20px]" />
          <Skeleton className="w-1/3 h-5 bg-[#ecedee] rounded-[20px]" />
        </div>
      ))}
    </div>
  );
};

export const PieSkeleton = () => {
  return (
    <Skeleton className="w-[150px] h-[150px] bg-[#ecedee] rounded-full mb-3" />
  );
};
